const KEYS = [
  ["kaaba", "Holy Kaaba"], ["clock_tower", "Masjid al-Haram & Clock Tower"], ["safa_marwa", "Safa & Marwa"],
  ["arafat", "Mount Arafat"], ["hira", "Jabal al-Nour (Hira)"], ["hotel_view", "Haram-view Hotel"],
  ["green_dome", "Green Dome, Madinah"], ["umbrellas", "Masjid an-Nabawi Umbrellas"],
  ["madinah_night", "Madinah at Night"], ["quba", "Quba Mosque"],
];

export const HOLY_PHOTOS = KEYS.map(([key, label]) => ({ key, label, src: `/holy/${key}.jpg` }));
export const holySrc = (key) => `/holy/${key}.jpg`;
